// 市政经营许可证
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let city = get(state, 'currentShopBaseDetail.docInfo.city', {})
  return {
    title: i18n.gettext('市政经营许可证'),
    content: [
      // {
      //   title: i18n.gettext('餐厅名称'),
      //   label: city.resName
      // },
      // {
      //   title: i18n.gettext('餐厅地址'),
      //   label: city.resAddr
      // },
      // {
      //   title: i18n.gettext('许可证编号'),
      //   label: city.licenseNum
      // },
      // {
      //   title: i18n.gettext('经营范围'),
      //   label: city.scope
      // },
      // {
      //   title: i18n.gettext('有效期'),
      //   content: city.validateDate
      // },
      {
        title: i18n.gettext('执照照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: city.licensePics
      }
    ]
  }
}
